import { Theme } from '@/app'
import { Organisation } from '@/features'
import { View, Text, DiscoverScoreModal } from '@/components'
import { useMediaQuery } from '@codeleap/web'
import React from 'react'
import { PerTopicEngagementScore, ReviewButtons } from './OrgPageComponents'

export type OrgMobilePageProps = {
  organisation: Organisation.T.Organisation
}

const OrgMobilePageComponent = (props: OrgMobilePageProps) => {
  const { organisation } = props

  const BREAKPOINT = 'small'

  const mediaQuery = Theme.media.down(BREAKPOINT)
  const isMobile = useMediaQuery(mediaQuery, { getInitialValueInEffect: false })
  const isBlurred = organisation.hide_scores

  return (
    <View variants={['column', 'gap:4', 'marginHorizontal:-2']}>
      {isMobile ? null : <ReviewButtons organisation={organisation} />}
      <View
        variants={['column', 'gap:2', 'padding:4', 'backgroundColor:neutral1', 'border-radius:large']}
        responsiveVariants={{
          [BREAKPOINT]: ['column', 'gap:2', 'padding:2', 'backgroundColor:neutral1', 'border-radius:large']
        }}
      >
        <Text text={'Hurd Score'} variants={['h2', 'bold']} />
        <PerTopicEngagementScore organisation={organisation} blurred={isBlurred} />
      </View>
      {/* {hasNps ? <NPS organisation={organisation}/> : null} */}
      {isMobile && <ReviewButtons organisation={organisation} />}
      {!isMobile && !!organisation?.details && (
        <Organisation.OrganisationDetails text={organisation?.details} title={organisation?.name} about="" />
      )}
      <Organisation.EmployeeReviews organisation={organisation} blurred={isBlurred} />
      {isBlurred && <DiscoverScoreModal organisation={organisation} />}
    </View>
  )
}

export const OrgMobilePage = React.memo(OrgMobilePageComponent as React.FC)
